<template>
	<div>
		<div class="confirmAdditional">
			<div class="additional_title">
				选择附加链接页面
				<span class="additional_subtitle">关于附加链接的说明</span>
			</div>
			<linkPage v-model="webpageList" ref="linkPage"></linkPage>
		</div>
		<div class="confirmAdditional">
			<el-row :gutter="20">
				<el-col :span="12">
					<div class="additional_title">附加宣传信息</div>
					<adDelete
						ref="titleForm"
						title="附加宣传说明"
						:Arr="propaganda"
						ispromotion
						:maxquantity="20"
						:minquantity="3"
						label="说明"
						:maxlength="25"
						@getList="getPropaganda"
					></adDelete>
					<div class="additional_title">附加结构化信息</div>
					<adDelete
						ref="plainForm"
						title="附加结构化说明"
						:Arr="structured"
						ispromotion
						:maxquantity="10"
						:minquantity="2"
						label="说明"
						:maxlength="25"
						@getList="getStructured"
					></adDelete>
				</el-col>
				<el-col :span="12">
					<prdPreview
						style="font-size: 14px; margin-top: 60px"
						:domain="'https://' + domain"
						:adTitleList="adTitleList"
						:adExplainList="propagandalist"
						:propagandalist="structureList"
						:webpageList="webpageList"
					>
					</prdPreview>
				</el-col>
			</el-row>
		</div>
		<confirmStep
			:activeValue="5"
			@toNext="toNext"
			@toPrev="toPrev"
			@toSkip="toSkip"
			class="footer"
		></confirmStep>
	</div>
</template>
<script>
import adDelete from '@/components/adsOnlineAuto/com/adDelete.vue';
import linkPage from '@/components/adsOnlineAuto/com/linkPage.vue';
import confirmStep from '@/components/adsOnlineAuto/confirmStep';
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
import prdPreview from '@/components/adsOnlineAuto/com/prd-preview.vue';
import vm from '@/common/confirm.js';
export default {
	components: {
		adDelete,
		linkPage,
		confirmStep,
		prdPreview,
	},
	data() {
		return {
			webpageList: [],
			propaganda: {},
			structured: {},
			domain: '',
			automationContentId: '',
			adTitleList: [],
		};
	},
	computed: {
		automationId() {
			return this.$route.query.id;
		},
		propagandalist() {
			return Object.values(this.propaganda).map(item => ({ content: item }));
		},
		structureList() {
			return Object.values(this.structured).map(item => ({ content: item }));
		},
	},
	methods: {
		async getproduct() {
			let res = await adsNewOnlineSer.getproduct({
				id: this.automationId,
			});
			let pomotionArr = res.data.productList.concat(res.data.productTypeList);
			this.automationContentId = pomotionArr[0].automationContentId;
		},
		async getAdTitleList() {
			this.getproduct().then(async () => {
				let res = await adsNewOnlineSer.productdetail({
					automationContentId: this.automationContentId,
					automationId: this.automationId,
				});
				this.adTitleList = res.data.adTitleList;
			});
		},
		async productadditional() {
			let res = await adsNewOnlineSer.productadditional({
				id: this.automationId,
			});
			let listOne = res.data.propagandaList;
			let listTwo = res.data.structureList;
			if (listOne && listOne.indexOf(null) == -1 && listOne.length !== 0) {
				let obj1 = listOne.map((item, index) => {
					return Object.assign({}, { content: item.content });
				});
				let re1 = obj1.map(function (item, index) {
					return JSON.parse(JSON.stringify(item).replace(/content/g, `content${index + 1}`));
				});
				let a1 = re1.reduce((acc, value) => {
					return { ...acc, ...value };
				});
				this.propaganda = a1;
			} else {
				this.propaganda = {
					content1: '',
					content2: '',
					content3: '',
					content4: '',
				};
			}
			if (listTwo && listTwo.indexOf(null) == -1 && listTwo.length !== 0) {
				let obj2 = listTwo.map((item, index) => {
					return Object.assign({}, { content: item.content });
				});
				let re2 = obj2.map(function (item, index) {
					return JSON.parse(JSON.stringify(item).replace(/content/g, `content${index + 1}`));
				});
				let a2 = re2.reduce((acc, value) => {
					return { ...acc, ...value };
				});
				this.structured = a2;
			} else {
				this.structured = {
					content1: '',
					content2: '',
					content3: '',
				};
			}
			this.webpageList = res.data.webpageList;
			this.domain = res.data.webpageList[0].domain;
		},
		async addproductadditional(param) {
			let propagandaList = Object.values(this.propaganda).map(item => ({ content: item }));
			let structureList = Object.values(this.structured).map(item => ({ content: item }));
			try {
				let res = await adsNewOnlineSer.addproductadditional({
					automationId: this.automationId,
					propagandaList: propagandaList,
					structureList: structureList,
					webpageList: this.webpageList,
					showFlag: param ? 1 : 0,
				});
				if (res.data == 'success') {
					this.$store.dispatch('getstepstatus', this.automationId);
					if (param) {
						this.$emit('toSkip', 6);
					} else {
						this.$emit('toNext');
					}
				}
			} catch (error) {
				console.log(error);
			}
		},
		getPropaganda(value) {
			this.propaganda = value;
		},
		getStructured(value) {
			this.structured = value;
		},
		toNext(param) {
			const a1 = new Promise((resolve, reject) => {
				this.$refs.titleForm.validate(valid => {
					if (valid) resolve();
				});
			});
			const a2 = new Promise((resolve, reject) => {
				this.$refs.plainForm.validate(valid => {
					if (valid) resolve();
				});
			});
			const a3 = new Promise((resolve, reject) => {
				let resArr = this.$refs.linkPage.$refs.linkCustom1?.map(element => {
					let validCopy;
					element.$refs.customForm.validate(valid => {
						validCopy = valid;
					});
					return validCopy;
				});
				let res = resArr.every(item => item);
				if (res) resolve();
			});
			Promise.all([a1, a2, a3]).then(() => {
				//全部验证通过

				if (this.webpageList && this.webpageList.length !== 0) {
					this.addproductadditional(param);
				} else {
					vm._warn('请选择附加链接页面');
				}
			});
		},
		toPrev() {
			this.$emit('toPrev');
		},
		toSkip() {
			this.toNext(1);
			// this.$emit('toSkip', 6);
		},
		requestData() {
			this.productadditional();
			this.getAdTitleList();
		},
	},
	created() {
		this.requestData();
	},
};
</script>
<style lang="scss" scoped>
.confirmAdditional {
	// max-height: 700px;
	background: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
	border-radius: 4px;
	padding: 20px 25px;
	// overflow: auto;
	margin-bottom: 10px;

	.additional_title {
		font-size: 18px;
		font-weight: 500;
		margin-bottom: 40px;

		.additional_subtitle {
			font-size: 14px;
			font-weight: 400;
			color: #666666;
		}
	}
}
</style>
